import localization from "../../../../assets/localization";
import constants from "../../../../utils/Constants";
import HandoffButton from "../Handoff/HandoffButton";
import WhatsappHandoffButton from "../Handoff/WhatsappHandoffButton";
import WideImageViewer from "../WideImageViewer";

export default function MessageMetadata({
  metadata,
  style,
  isMobile,
  setFullScreen,
  showHandoffButton,
  language,
  assistantChatConfiguration,
}: any) {
  return (
    <>
      {metadata?.map((meta: any, metaIndex: number) => {
        switch (meta.type) {
          case "image":
            return meta.value.startsWith("https://i.ibb.co/") ? (
              <div className="message-attachment">
                <WideImageViewer
                  image={meta.value}
                  maxHeight={
                    isMobile
                      ? constants.DIMENSIONS.MOBILE.OPEN.HEIGHT_STRING
                      : constants.DIMENSIONS.DESKTOP.OPEN.HEIGHT_STRING
                  }
                  maxWidth={
                    isMobile
                      ? constants.DIMENSIONS.MOBILE.OPEN.WIDTH_STRING
                      : constants.DIMENSIONS.DESKTOP.OPEN.WIDTH_STRING
                  }
                  setFullScreen={(value: any) =>
                    setFullScreen((prev: any) => ({
                      ...prev,
                      isWIVFullScreen: value,
                    }))
                  }
                  isFullScreen={false}
                  setFullScreenImage={(image: any) =>
                    setFullScreen((prev: any) => ({
                      ...prev,
                      WIVfullScreenImage: image,
                    }))
                  }
                />
              </div>
            ) : (
              <img
                key={metaIndex}
                src={meta.value}
                alt={localization.get(language).attachment_alt}
                className="message-attachment"
              />
            );
          case "human_handoff_form":
            return (
              // Two ways to reach a person, offered together: leave your
              // details here, or move the conversation to WhatsApp.
              <div key={metaIndex} className="handoff-actions">
                <HandoffButton
                  setHandoffFormFullscreen={(value: any) =>
                    setFullScreen((prev: any) => ({
                      ...prev,
                      isHandoffFormFullScreen: value,
                    }))
                  }
                  show={showHandoffButton}
                  label={localization.get(language).speak_with_operator}
                  style={style}
                />
                <WhatsappHandoffButton
                  show={
                    showHandoffButton &&
                    assistantChatConfiguration?.isWhatsappHandoffEnabled === true
                  }
                  phoneNumber={assistantChatConfiguration?.phoneNumber}
                  language={language}
                />
              </div>
            );
          default:
            return null;
        }
      })}
    </>
  );
}
